import React, { useMemo } from 'react'
import routesConfig from 'lib/routesConfig'
import { useAppSelector } from 'redux/toolkit/hooks'
import CMLLink from 'components/libs/layout/CMLLink'
import appConfig from 'config/appConfig'
import { Auth } from 'v2/modules/lib'

const CMLLinkSelector = () => {
  const { activePath, accessTokenObject, authDomainPolicies, ipirAccount } = useAppSelector(_store => ({
    activePath: _store.app.activePath,
    accessTokenObject: _store.auth.accessTokenObject,
    authDomainPolicies: _store.auth.accessTokenObject?.authDomainPolicies,
    ipirAccount: _store.ipir.account
  }))

  const isEmailLogEnabled = useMemo(() => {
    if (!accessTokenObject?.bccAccountId || !authDomainPolicies) {
      return false
    }
    const auth = Auth(authDomainPolicies)
    return auth.hasEmailProtectionAccess(accessTokenObject.bccAccountId)
  }, [accessTokenObject?.bccAccountId, authDomainPolicies])

  const hasGoogleTenant = useMemo(() => {
    if (!ipirAccount?.accessTokens) {
      return false
    }
    return ipirAccount.accessTokens.some(token => token.provider?.toLowerCase() === 'google')
  }, [ipirAccount])

  const isEmailLogActive = useMemo(() => activePath.id === routesConfig.EMAIL_LOG?.id, [activePath.id])

  switch (true) {
    case !!accessTokenObject && isEmailLogEnabled && !hasGoogleTenant && !isEmailLogActive && appConfig.APP.IS_ADMIN: {
      return <CMLLink />
    }
    default: {
      return null
    }
  }
}

export default CMLLinkSelector
